import { Image } from "@react-pdf/renderer";
import React from "react";
import { MapObject } from "../../models/MapObject";
import { iconType, mapObjectColor } from "../Helper/Map";
import FontAwesomeIconPDF from "./FontAwesomeIconPDF";
import IconMatcher from "./SVGIconMatch";

// A mappable's map avatar for react-pdf, matching AreaAvatar on screen: its PNG icon, its tinted SDF icon, or a
// geometry glyph in its color when it has no icon.
const PDFMappableAvatar: React.FC<{ mapObject: MapObject | null | undefined }> = ({ mapObject }) => {
    if (!mapObject) return null;

    if (!mapObject.icon) {
        return (
            <FontAwesomeIconPDF
                faIcon={iconType(mapObject.geometry)}
                style={{ color: mapObjectColor(mapObject), width: "12pt" }}
            />
        );
    }

    if (mapObject.icon.includes("sdf")) {
        return <IconMatcher mapObject={mapObject} />;
    }

    return <Image style={{ width: "12pt" }} src={`/img/png/map/${mapObject.icon}.png`} />;
};

export default PDFMappableAvatar;
